import { render } from "./SortableTable.vue?vue&type=template&id=03859771"
import script from "./SortableTable.vue?vue&type=script&lang=js"
export * from "./SortableTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__